// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tXHP","question":"styles_question__2dY2U","description":"styles_description__3Cqh0"};